import {
  __decorateClass,
  component_styles_default,
  theme_styles_default
} from "./chunk.U4VUMZVF.js";

// src/components/spinner/spinner.ts
import { LitElement, html } from "lit";
import { property } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";

// src/components/spinner/spinner.styles.ts
import { css } from "lit";
var spinner_styles_default = css`
	${theme_styles_default}
	${component_styles_default}

.yotpo-spinner-three-bounce div {
		width: 12px; /* 0.75rem */
		height: 12px; /* 0.75rem */
		background-color: currentColor;
		border-radius: 100%;
		display: inline-block;
		-webkit-animation: yotpo-threeBounceDelay 1.4s infinite ease-in-out;
		animation: yotpo-threeBounceDelay 1.4s infinite ease-in-out;
		-webkit-animation-fill-mode: both;
		animation-fill-mode: both;
	}

	.yotpo-spinner-three-bounce.yotpo-spinner {
		margin: 0 auto;
		text-align: center;
	}

	.yotpo-spinner-three-bounce .yotpo-bounce1 {
		-webkit-animation-delay: -0.32s;
		animation-delay: -0.32s;
	}

	.yotpo-spinner-three-bounce .yotpo-bounce2 {
		-webkit-animation-delay: -0.16s;
		animation-delay: -0.16s;
	}

	@-webkit-keyframes yotpo-threeBounceDelay {
		0%,
		80%,
		100% {
			-webkit-transform: scale(0);
			transform: scale(0);
		}
		40% {
			-webkit-transform: scale(1);
			transform: scale(1);
		}
	}
	@keyframes yotpo-threeBounceDelay {
		0%,
		80%,
		100% {
			-webkit-transform: scale(0);
			transform: scale(0);
		}
		40% {
			-webkit-transform: scale(1);
			transform: scale(1);
		}
	}
`;

// src/components/spinner/spinner.ts
var YotpoSpinner = class extends LitElement {
  constructor() {
    super(...arguments);
    this.color = "var(--yotpo-color-general-70)";
    this.size = "var(--yotpo-button-font-size)";
  }
  render() {
    return html`
			<div
				class="yotpo-spinner yotpo-spinner-three-bounce"
				style=${styleMap({ color: this.color, height: this.size })}
			>
				<div class="yotpo-bounce1" style=${styleMap({ height: this.size, width: this.size })}></div>
				<div class="yotpo-bounce2" style=${styleMap({ height: this.size, width: this.size })}></div>
				<div class="yotpo-bounce3" style=${styleMap({ height: this.size, width: this.size })}></div>
			</div>
		`;
  }
};
YotpoSpinner.styles = spinner_styles_default;
__decorateClass([
  property({ reflect: true })
], YotpoSpinner.prototype, "color", 2);
__decorateClass([
  property({ reflect: true })
], YotpoSpinner.prototype, "size", 2);
if (!customElements.get("yotpo-spinner")) {
  customElements.define("yotpo-spinner", YotpoSpinner);
}

export {
  YotpoSpinner
};
